import {
  inlineDownloadPlugin,
  inlineDownloadWithoutSegmentPlugin as originalInlineDownloadWithoutSegmentPlugin,
  inlineDownloadWithoutFilterstatePlugin as withoutFilterStatePlugin,
} from '@bingads-webui-campaign/projection-grid-inline-download';
import { merge } from '@bingads-webui-universal/primitive-utilities';
import globalConfig from '@bingads-webui-component-legacy/config/index';
import state from '@bingads-webui-component-legacy/state/index';
import { DownloadViewV1, DownloadViewV2 } from '@bingads-webui-campaign-legacy/griddownload/view/adapter';

const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/bingadsgrid');

function wrapPlugin(originalPlugin) {
  return (definePlugin) => originalPlugin((name, dependencies, callback) => {
    return definePlugin(name, dependencies, (config, ...restDependencies) => {
      const Permissions = globalConfig.get('permissions') || {};
      const {
        isInlineDownloadReportV2Enabled = Permissions.IsInlineDownloadReportV2Enabled,
      } = config.plugins.inlineDownload;
      const ReportEmailRule = state.get('$ReportEmailRule');

      state.unset('$ReportEmailRule');

      return callback(merge({
        plugins: {
          inlineDownload: {
            i18n,
            DownloadView: isInlineDownloadReportV2Enabled ? DownloadViewV2 : DownloadViewV1,
            ReportEmailRule,
          },
        },
      }, config), ...restDependencies);
    });
  });
}

/**
 * @typedef InlineDownloadConfig
 * @type {object}
 * @property {string} button - The id of the download button.
 * It must match the download button id defined in toolbar plugin.
 * @property {boolean} isAvailable - Whether the download feature is enabled
 * @property {string[]} segmentationTypes
 * @property {string} entity
 * @property {string} gridId
 * @property {Object.<string, InlineDownloadColumns>} columns - DEPRECATED: The override column config.
 *  add your column-property mapping into @bingads-webui-campaign/inline-download-grids-metadata
 *
 * @deprecated
 * @typedef InlineDownloadColumns
 * @type {InlineDownloadColumnConfig|InlineDownloadColumnConfig[]}
 *
 * @deprecated
 * @typedef InlineDownloadColumnConfig
 * @type {object}
 * @property {string} property - The property path in form of 'foo/bar'.
 * @property {string} title - The localized column header string.
 */

export default wrapPlugin(inlineDownloadPlugin);

export const inlineDownloadWithoutSegmentPlugin = wrapPlugin(originalInlineDownloadWithoutSegmentPlugin);

export const inlineDownloadWithoutFilterStatePlugin = wrapPlugin(withoutFilterStatePlugin);
